// extracted by mini-css-extract-plugin
module.exports = {"td":"style_td__3s8Mu"};